import React, { useEffect, useState } from 'react';
import { Button, Typography, Card, Row, Col, Badge } from 'antd';
import  Footer  from '../Components/Footer.jsx';
import { Link } from 'react-router-dom';
import {
  PictureOutlined,
  RocketOutlined,
  ThunderboltOutlined,
  BgColorsOutlined,
  LinkedinOutlined,
  InstagramOutlined
} from '@ant-design/icons';
import carousel1 from '../images/carousel-slides (70)-images-0.jpg';
import carousel2 from '../images/carousel-slides (70)-images-1.jpg';
import carousel3 from '../images/carousel-slides (70)-images-4.jpg';
import carousel4 from '../images/carousel-slides (73)-images-0.jpg';
import carousel5 from '../images/carousel-slides (73)-images-1.jpg';
import carousel6 from '../images/carousel-slides (73)-images-2.jpg';
import carousel7 from '../images/carousel-slides (73)-images-9.jpg';



import { useInView } from 'react-intersection-observer';

const { Title, Paragraph } = Typography;

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // Standard mobile breakpoint
    };

    // Check initially
    checkMobile();

    // Add event listener
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return isMobile;
};

const BokehBackground = ({ isMobile }) => {
  if (isMobile) return null; // Don't render on mobile

  return (
    <div className="fixed inset-0 w-screen h-screen overflow-hidden pointer-events-none">
      {[...Array(30)].map((_, i) => (
        <div
          key={i}
          className={`absolute rounded-full blur-2xl animate-float-slow opacity-60
            ${i % 4 === 0 ? 'bg-purple-300' : 
              i % 4 === 1 ? 'bg-pink-300' : 
              i % 4 === 2 ? 'bg-blue-300' : 'bg-indigo-300'}`}
          style={{
            width: `${Math.random() * 300 + 100}px`,
            height: `${Math.random() * 300 + 100}px`,
            left: `${Math.random() * 100}%`,
            top: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 10}s`,
            animationDuration: `${Math.random() * 20 + 15}s`,
            transform: `rotate(${Math.random() * 360}deg)`
          }}
        />
      ))}
    </div>
  );
};

const FeatureCard = ({ emoji, title, description }) => (
  <div 
    className="group p-8 relative overflow-hidden transition-all duration-300 hover:scale-105"
    style={{ 
      height: '100%', 
      borderRadius: '24px',
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(20px)',
      boxShadow: '0 4px 24px -1px rgba(0, 0, 0, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.5)',
    }}
  >
    {/* Animated gradient background */}
    <div 
      className="absolute inset-0 opacity-0 group-hover:opacity-20 transition-opacity duration-500"
      style={{
        background: 'linear-gradient(120deg, #a855f7 0%, #ec4899 100%)',
      }}
    />

    {/* Emoji with container */}
    <div className="relative z-10 mb-6">
      <div className="relative inline-block">
        <span className="text-6xl transform group-hover:scale-110 transition-transform duration-300">
          {emoji}
        </span>
        <div className="absolute -inset-4 bg-gradient-to-br from-purple-600/10 to-pink-600/10 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
      </div>
    </div>

    {/* Title with animated gradient */}
    <h3 className="relative z-10 text-xl font-bold mb-4 bg-gradient-to-r from-gray-900 to-gray-700 bg-clip-text text-transparent group-hover:from-purple-600 group-hover:to-pink-600 transition-all duration-300">
      {title}
    </h3>

    {/* Description with enhanced typography */}
    <p className="relative z-10 text-gray-600 leading-relaxed group-hover:text-gray-700 transition-colors duration-300">
      {description}
    </p>

    {/* Decorative corner elements */}
    <div className="absolute top-0 right-0 w-24 h-24 opacity-0 group-hover:opacity-10 transition-opacity duration-500">
      <div className="absolute inset-0 bg-gradient-to-br from-purple-400 to-pink-400 transform rotate-45" />
    </div>
    <div className="absolute bottom-0 left-0 w-16 h-16 opacity-0 group-hover:opacity-10 transition-opacity duration-500">
      <div className="absolute inset-0 bg-gradient-to-tr from-purple-400 to-pink-400 transform -rotate-45" />
    </div>
  </div>
);

const titleStyles = {
  title: {
    fontSize: '3.5rem',
    fontWeight: '900', // Extra bold
    backgroundImage: 'linear-gradient(-45deg, #6366f1, #a855f7, #ec4899, #6366f1)',
    backgroundSize: '200% 200%',
    backgroundClip: 'text',
    textFillColor: 'transparent',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animation: 'gradient 5s ease infinite',
  },
  titlemain: {
    
    fontWeight: '900', // Extra bold
    backgroundImage: 'linear-gradient(-45deg, #6366f1, #a855f7, #ec4899, #6366f1)',
    backgroundSize: '200% 200%',
    backgroundClip: 'text',
    textFillColor: 'transparent',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    animation: 'gradient 5s ease infinite',
  },
  wrapper: {
    position: 'relative',
    display: 'inline-block',
  },
  glow: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    filter: 'blur(20px)',
    opacity: 0.4,
    backgroundImage: 'linear-gradient(-45deg, #6366f1, #a855f7, #ec4899, #6366f1)',
    backgroundSize: '200% 200%',
    animation: 'gradient 5s ease infinite',
    zIndex: -1,
  }
};

const keyframes = `
@keyframes gradient {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

@keyframes stackCard {
  0% { 
    transform: translateY(0) translateX(0) rotate(0);
    position: relative;
  }
  100% { 
    transform: translateY(var(--stack-translate)) translateX(var(--stack-shift)) rotate(var(--stack-rotate));
    position: relative;
  }
}`;

const CarouselCard = ({ image, isRight }) => (
  <div 
    className="relative"
    style={{
      width: '250px',
      transform: `rotate(${isRight ? '0' : '0'}deg)`,
      //marginLeft: isRight ? 'auto' : '0',
      //marginRight: isRight ? '0' : 'auto',
    }}
  >
    <div className="group relative transform transition-all duration-300 hover:-translate-y-2 hover:shadow-2xl">
      <div className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-pink-500/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity" />
      <img 
        src={image}
        alt="Carousel Example"
        className="rounded-xl shadow-lg w-full object-cover"
        style={{ height: '300px' }}
      />
    </div>
  </div>
);

const HomeScreen = () => {
  const isMobile = useIsMobile();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2
  });

  // Add useEffect to inject the keyframes into the document head
  React.useEffect(() => {
    // Create style element
    const styleElement = document.createElement('style');
    styleElement.textContent = keyframes;
    document.head.appendChild(styleElement);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(styleElement);
    };
  }, []);

  const features = [
    {
      emoji: "⚡️",
      title: "Custom Design Elements",
      description: "Generate professional carousel content with background images, text, and design elements"
    },
    {
      emoji: "🎨",
      title: "Multiple Templates",
      description: "Choose from various LinkedIn and Instagram optimized templates"
    },
    {
      emoji: "✨",
      title: "Custom Styling",
      description: "Personalize colors, fonts, and design elements to match your brand"
    },
    {
      emoji: "🚀",
      title: "One-Click Export",
      description: "Export your carousels directly in LinkedIn-ready PDF format"
    }
  ];

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Only render heavy backgrounds on desktop */}
      <BokehBackground isMobile={isMobile} />
      
      {/* Simplified background for mobile */}
      <div className={`absolute inset-0 ${
        isMobile 
          ? 'bg-gradient-to-b from-purple-50 to-white' 
          : 'bg-[conic-gradient(at_top_right,_var(--tw-gradient-stops))] from-indigo-200/80 via-purple-100/80 to-pink-100/80'
      } -z-10`} />

      {/* Only render animated gradients on desktop */}
      {!isMobile && (
        <>
          <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-to-bl from-purple-300/30 to-blue-300/30 rounded-full blur-3xl -z-10 animate-pulse" />
          <div className="absolute bottom-0 left-0 w-2/3 h-2/3 bg-gradient-to-tr from-pink-200/30 to-indigo-300/30 rounded-full blur-3xl -z-10 animate-pulse" />
        </>
      )}

      {/* Hero Section */}
      <div className="container mx-auto px-4 pt-24 pb-40 relative">
        <div className="text-center max-w-4xl mx-auto">
          <div className="inline-block mb-4 px-6 py-2 rounded-full bg-gradient-to-r from-purple-100 to-pink-100 text-purple-700 text-sm font-semibold shadow-lg">
            🚀 The easiest way to create LinkedIn carousels
          </div>
          <div style={titleStyles.wrapper}>
            <h1 style={titleStyles.titlemain } className="text-8xl mb-8">
              CarouselPost.in
            </h1>
            <h1 style={titleStyles.title } className="text-6xl mb-8">
              Create Engaging LinkedIn Carousels in Minutes
            </h1>
            <div style={titleStyles.glow}></div>
          </div>
          <Paragraph className="text-xl text-gray-600 mb-12 leading-relaxed">
            Transform your content into stunning carousel posts that capture attention and drive engagement.
            No design skills needed - just let AI do the magic.
          </Paragraph>
          <div className="flex justify-center gap-4">
            <Link to="/signin">
              <Button 
                type="primary" 
                size="large"
                className="h-14 px-8 text-lg bg-gradient-to-r from-purple-600 via-fuchsia-500 to-pink-500 border-none hover:from-purple-700 hover:via-fuchsia-600 hover:to-pink-600 shadow-lg hover:shadow-xl transition-all"
              >
                Create Your Carousel
              </Button>
            </Link>
            {/* <Button 
              size="large" 
              className="h-14 px-8 text-lg flex items-center gap-2 hover:bg-gray-50 shadow-lg"
              icon={<span className="text-purple-600">▶</span>}
            >
              Watch Demo
            </Button> */}
          </div>
        </div>
      </div>

      {/* Carousel Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 gap-12">
          {/* Content */}
          <div className="text-center space-y-6 max-w-2xl mx-auto mb-12">
            <h2 className="text-4xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-500">
              Professional Templates
            </h2>
            <p className="text-xl text-gray-600 leading-relaxed">
              Choose from our collection of carefully designed templates.
            </p>
          </div>

          {/* Video Container */}
          <div className="relative w-full max-w-4xl mx-auto p-6">
            {/* Gradient Background for Video Section */}
            <div className="absolute inset-0 bg-gradient-to-r from-purple-100/50 via-pink-50/50 to-indigo-100/50 rounded-3xl transform rotate-1"></div>
            
            {/* Video Wrapper */}
            <div className="relative group">
              {/* Decorative Elements */}
              <div className="absolute -inset-1 bg-gradient-to-r from-purple-600 to-pink-600 rounded-3xl opacity-20 group-hover:opacity-30 blur transition-all duration-500 group-hover:blur-xl"></div>
              
              {/* Streamable Video Embed */}
              <div className="relative rounded-2xl overflow-hidden shadow-2xl transform transition-transform duration-500 group-hover:scale-[1.01]">
                <div style={{ position: 'relative', width: '100%', height: '0px', paddingBottom: '41.860%' }}>
                  <iframe 
                    src="https://streamable.com/e/r4phkq?"
                    allow="fullscreen"
                    allowFullScreen
                    style={{
                      border: 'none',
                      width: '100%',
                      height: '100%',
                      position: 'absolute',
                      left: '0px',
                      top: '0px',
                      overflow: 'hidden',
                      borderRadius: '1rem'
                    }}
                  />
                </div>
              </div>
            </div>

            {/* Caption */}
            <div className="text-center mt-6">
              <p className="text-lg text-gray-600">
                Watch how easy it is to create stunning carousels ✨
              </p>
            </div>
          </div>
          
          {/* Cards Container */}
          <div className="space-y-24">
            {/* Business Style Section - Left Aligned */}
            {/* <div>
              <h3 className="text-xl font-bold text-purple-600 mb-8 pl-4">Professional Business Style</h3>
              <div className="flex flex-wrap gap-1 justify-start">
                <CarouselCard image={carousel1} isRight={false}  />
                <CarouselCard image={carousel2} isRight={false} />
                <CarouselCard image={carousel3} isRight={false} />
              </div>
            </div> */}

            {/* Creative Style Section - Right Aligned */}
            {/* <div>
              <h3 className="text-xl font-bold text-purple-600 mb-8 text-right pr-4">Creative Modern Style</h3>
              <div className="flex flex-wrap gap-1 justify-end">
                <CarouselCard image={carousel4} isRight={true} />
                <CarouselCard image={carousel5} isRight={true} />
                <CarouselCard image={carousel6} isRight={true} />
                <CarouselCard image={carousel7} isRight={true} />
              </div>
            </div> */}
          </div>
          
        </div>
      </div>

      {/* Enhanced Features Section */}
      <div className="container mx-auto px-4 py-24 relative">
        <div className="absolute inset-0 bg-gradient-to-b from-white/0 via-purple-50/50 to-white/0 rounded-3xl" />
        <Title level={2} className="text-center text-4xl mb-20">
          Everything You Need to Create
          <br />
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 via-fuchsia-500 to-pink-500">
            Professional Carousels
          </span>
        </Title>
        <Row gutter={[32, 32]}>
          {features.map((feature, index) => (
            <Col xs={24} sm={12} lg={6} key={index}>
              <FeatureCard {...feature} />
            </Col>
          ))}
        </Row>
      </div>

      {/* Enhanced Platform Support Section */}
      <div className="bg-gradient-to-b from-white via-purple-50 to-white py-24">
        <div className="container mx-auto px-4">
          <Title level={2} className="text-center text-4xl mb-16">
            <span className="bg-clip-text text-transparent bg-gradient-to-r from-purple-600 to-pink-500">
              Optimized for Your Favorite Platforms
            </span>
          </Title>
          <div className="flex justify-center gap-20 text-4xl text-gray-600">
            <div className="text-center transform hover:scale-110 transition-transform duration-300">
              <div className="w-32 h-32 rounded-2xl bg-gradient-to-br from-white to-purple-50 shadow-lg flex items-center justify-center mb-6">
                <LinkedinOutlined className="text-7xl text-[#0A66C2]" />
              </div>
              <p className="text-xl font-semibold">LinkedIn</p>
            </div>
            <div className="text-center transform hover:scale-110 transition-transform duration-300">
            <Badge.Ribbon style={{
              width: '80%',
              fontSize: '10px',
            }} text="Coming Soon" color="pink">
              <div className="w-32 h-32 rounded-2xl bg-gradient-to-br from-white to-pink-50 shadow-lg flex items-center justify-center mb-6">
                <InstagramOutlined className="text-7xl text-[#E4405F]" />
              </div>
              </Badge.Ribbon>
              <p className="text-xl font-semibold">Instagram</p>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced CTA Section */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-purple-600 via-fuchsia-500 to-pink-500 -z-10" />
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iZ3JpZCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBkPSJNIDQwIDAgTCAwIDAgMCA0MCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLW9wYWNpdHk9IjAuMSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-10 -z-10" />
        <div className="container mx-auto px-4 py-24 text-center">
          <Title level={2} className="text-white text-5xl mb-8">
            Ready to Create Your First Carousel?
          </Title>
          <Paragraph className="text-xl text-purple-100 mb-12 max-w-2xl mx-auto">
            Join thousands of creators who are already using our platform to create
            engaging content that stands out on LinkedIn.
          </Paragraph>
          <Link to="/signin">
            <Button 
              size="large"
              className="h-14 px-12 text-lg bg-white text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-500 hover:bg-gray-50 shadow-lg hover:shadow-xl transition-all font-semibold"
            >
              Get Started Now
            </Button>
          </Link>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HomeScreen;